import { render, staticRenderFns } from "./FavoriteTile.vue?vue&type=template&id=fca557ea"
import script from "./FavoriteTile.vue?vue&type=script&lang=js"
export * from "./FavoriteTile.vue?vue&type=script&lang=js"
import style0 from "./FavoriteTile.vue?vue&type=style&index=0&id=fca557ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports